// hooks/useAuth.js

import { useEffect, useState } from 'react';
import {jwtDecode} from "jwt-decode";

export const useAuth = () => {
    const raw = localStorage.getItem("authToken");
    let token = raw ? JSON.parse(raw) : null;
    const flag = Boolean(token);
    const decoded = token && typeof token === "string" ? jwtDecode(token) : null;
    const userId = decoded?.id; // Example field
    const email = decoded?.email;
    const role = decoded?.role;
    const roleAccess = JSON.parse(localStorage.getItem("roleAccess")) || []; 
    const [isAuthenticated, setIsAuthenticated] = useState(flag); // Example state for authentication

  useEffect(()=>{
    setIsAuthenticated(flag)
  },[flag])
  // Example function to log in user
  const login = () => {
        setIsAuthenticated(false);
    // Logic to set authentication token, user data, etc.
  };

  // Example function to log out user
  const logout = () => {
    setIsAuthenticated(false);
    localStorage.clear();
    // Logic to clear authentication token, user data, etc.
  };

  return {
    isAuthenticated,
    login,
    logout,
    roleAccess,
    userId,
    email,
    role
  };
};
